// extracted by mini-css-extract-plugin
export default {"hiddenCountText":"JqR3MqW_BZIV0UoyA1p_"};